import { render, staticRenderFns } from "./IssuesContainer.vue?vue&type=template&id=89e5bcc4&scoped=true&"
import script from "./IssuesContainer.vue?vue&type=script&lang=js&"
export * from "./IssuesContainer.vue?vue&type=script&lang=js&"
import style0 from "./IssuesContainer.vue?vue&type=style&index=0&id=89e5bcc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e5bcc4",
  null
  
)

export default component.exports